/*****************************************
 * * IMPORTS
 *****************************************/
// React libraries
import React from 'react';

// styles and images
import logo from '../../assets/icons/logo.png';
import styles from './Footer.module.css';

// components

/*****************************************
 * * CREATE COMPONENT
 *****************************************/
function Footer() {
  return (
    <footer>
      <a className={styles.logo} href="https://lbscience.org//">
        <img src={logo} alt="logo" aria-hidden="true" />
      </a>
      <p>פיתוח: משפחת אורנשטיין</p>
    </footer>
  );
}

export default Footer;
